export const productStatusValues = {
  active: 'active',
  draft: 'draft',
  archived: 'archived',
  unlisted: 'unlisted',
}

export const productStatusOptions = [
  {
    label: 'Activo',
    value: productStatusValues.active,
  },
  {
    label: 'Borrador',
    value: productStatusValues.draft,
  },
  {
    label: 'Archivado',
    value: productStatusValues.archived,
  },
  {
    label: 'No listado',
    value: productStatusValues.unlisted,
  },
]
